export function roundNumberStr(value, decimals) {
    if(decimals !== null && decimals !== undefined) {
        let originalNum = Number(value);
        let roundedStr = originalNum.toFixed(decimals);
        return Number(roundedStr) === originalNum ? value : roundedStr;
    } else {
        return value;
    }
}